<template>
  <v-row class="flex-nowrap pa-0 pl-1">
    <v-col v-if="eachRowOnNewLine"
           class="align-start justify-start pt-1 pb-1"
           :class="{ 'flex-grow-0': truncateRow }"
           :style="{ 'max-width': 'fit-content' }">
      <v-row class="pl-2 d-block" :class="{ 'text-truncate': truncateRow }"
             v-for="row of availableRows" :key="row">
        {{ row }}
      </v-row>
    </v-col>

    <v-col class="align-start justify-start pl-2 pb-1 pt-0"
           :class="{ 'text-truncate text-no-wrap': truncateRow }"
           :id="uniqueId" v-else>
      <div class="d-inline-block mc-bar-item"
           v-for="(row, index) in rows" :key="index">
        {{ row }}<span v-if="includeCommas && index !== (rows.length - 1)">,&nbsp;</span>
      </div>
    </v-col>

    <v-col class="flex-grow-0 pb-1" :class="{ 'pt-0': !eachRowOnNewLine, 'pt-1': eachRowOnNewLine }"
           v-if="toggleButtonVisible">
      <v-btn icon x-small @click="toggleCollapse">
        <v-icon size="21" v-if="collapsed">mdi-chevron-down</v-icon>
        <v-icon size="21" v-else>mdi-chevron-up</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { debounce } from 'lodash';

export default {
  name: 'CollapsibleBar',
  props: ['rows', 'eachRowOnNewLine', 'includeCommas'],
  data: () => ({
    collapsed: true,
    isLineWrapped: false,
    uniqueId: `mc-wrapped-line-${Math.random().toString().slice(2)}`,
  }),
  async mounted() {
    await this.waitForElement(`#${this.uniqueId}`);

    this.listener = debounce(
      this.calculateView.bind(this), 150, {
        trailing: true,
        leading: true,
      },
    );

    window.addEventListener('resize', this.listener);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.listener);
  },
  methods: {
    toggleCollapse() {
      this.collapsed = !this.collapsed;
    },
    calculateView() {
      const list = document.getElementById(this.uniqueId);
      const { width: displayedWidth } = list.getBoundingClientRect();
      const spans = Array.from(list.getElementsByClassName('mc-bar-item'));

      const totalWidth = spans.reduce(
        (width, span) => width + span.getBoundingClientRect().width,
        0,
      );

      this.isLineWrapped = totalWidth > displayedWidth;
    },
    waitForElement(selector) {
      return new Promise((resolve) => {
        let element = document.querySelector(selector);
        if (element) return resolve(element);

        const observer = new MutationObserver((mutations, ctx) => {
          element = document.querySelector(selector);
          if (!element) return;
          ctx.disconnect();
          resolve(element);
        });

        return observer.observe(document, {
          childList: true,
          subtree: true,
        });
      });
    },
  },
  computed: {
    availableRows() {
      return this.collapsed && this.eachRowOnNewLine
        ? this.rows.slice(0, 1)
        : this.rows;
    },
    toggleButtonVisible() {
      return (this.eachRowOnNewLine && this.rows.length > 1)
        || (!this.eachRowOnNewLine && this.isLineWrapped);
    },
    truncateRow() {
      return (!this.eachRowOnNewLine || this.rows.length > 1)
        && this.collapsed;
    },
  },
};
</script>
